import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const RazorPage = () => {
  const media = 
  [
    '/images/razor.webp'
 ];

  return (
    <div className="razor-page">
      <ProjectTemplate
        title="R_A_Z_O_R"
        year="2018"
        sections={[
          {
            type: "description",
            text: 'R_A_Z_O_R is a live audiovisual performance which experiments with the purpose and effects of visuals in dance music. Using similar visuals and sound processes as in O.T.B.B, this projects puts the same material in a different context. The half-time beats are either constructed on-the-spot or made beforehand using a self-built sequencer in Supercolider. Like in O.T.B.B, both sound and image are generated live.',
          },
          {
            type: "video",
            links: [
                
              "https://www.youtube.com/embed/EqLyqbjeEGk?si=h-cTQyAz1xF7mnWI?modestbranding=1&showinfo=0",
            ],
            
          },
          {
            type: "video",
            links: [
                
              "https://www.youtube.com/embed/Gz58GYh_9nc?si=w9lntO4cyZRoWqwS?modestbranding=1&showinfo=0",
            ],
            
          }
        ]}
      />
    </div>
  );
};

export default RazorPage;
